module.exports = __webpack_public_path__ + "static/res-2fce5fe95bf7f3a1495cb9444b86b3ac.png";